import r from "../../shared-lib/braze-shared-lib.js";
export function logDeprecationWarning(e, a, i) {
  var s = "The '".concat(e, "' ").concat(a, " is deprecated.");
  i && (s += " Please use '".concat(i, "' instead.")), r.D.warn(s);
}